<template>
  <div class="admin-page">
    <h2 class="page-title">合伙人申请审核</h2>
    <div class="admin-toolbar">
      <el-select v-model="filters.status" placeholder="状态" clearable @change="fetchList">
        <el-option label="待审核" value="pending" />
        <el-option label="已通过" value="approved" />
        <el-option label="已拒绝" value="rejected" />
      </el-select>
      <el-button type="primary" @click="fetchList">查询</el-button>
    </div>
    <el-table :data="items" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="userId" label="用户ID" width="90" />
      <el-table-column prop="realName" label="姓名" width="100" />
      <el-table-column prop="phone" label="电话" width="120" />
      <el-table-column prop="intro" label="说明" min-width="160" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90">
        <template #default="s">{{ statusLabel(s.row.status) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="s">
          <template v-if="s.row.status === 'pending'">
            <el-button link type="success" @click="review(s.row, 'approve')">通过</el-button>
            <el-button link type="danger" @click="openReject(s.row)">拒绝</el-button>
          </template>
          <span v-else>—</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="rejectVisible" title="拒绝申请" width="560px">
      <AdminRejectReasonField
        v-model="rejectReply"
        category="partner"
        :rows="3"
        placeholder="拒绝原因；可点选上方常见原因"
      />
      <template #footer>
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="danger" :loading="processing" @click="confirmReject">确认拒绝</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchAdminPartnerApplications,
  reviewPartnerApplication,
  PARTNER_STATUS_LABELS
} from '@/utils/userHub'
import AdminRejectReasonField from '@/components/AdminRejectReasonField.vue'

export default {
  name: 'AdminPartnerApplications',
  components: { AdminRejectReasonField },
  data() {
    return {
      loading: false,
      processing: false,
      items: [],
      filters: { status: 'pending' },
      rejectVisible: false,
      rejectReply: '',
      currentRow: null
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    statusLabel(s) {
      return PARTNER_STATUS_LABELS[s] || s
    },
    async fetchList() {
      this.loading = true
      try {
        const data = await fetchAdminPartnerApplications({
          page: 1,
          pageSize: 50,
          status: this.filters.status || undefined
        })
        this.items = data.items || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async review(row, action, adminReply = '') {
      this.processing = true
      try {
        await reviewPartnerApplication({
          applicationId: row.id,
          action,
          adminReply
        })
        this.$message.success('处理成功')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '处理失败')
      } finally {
        this.processing = false
      }
    },
    openReject(row) {
      this.currentRow = row
      this.rejectReply = ''
      this.rejectVisible = true
    },
    confirmReject() {
      if (!this.rejectReply.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.review(this.currentRow, 'reject', this.rejectReply.trim())
      this.rejectVisible = false
    }
  }
}
</script>

<style scoped>
.page-title { margin: 0 0 16px; }
.admin-toolbar { display: flex; gap: 12px; margin-bottom: 16px; }
</style>
